exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-select.style-selector .vs__dropdown-toggle .vs__selected-options .vs__selected{\n  background-color: #b1865b !important;\n  color: white !important;\n  padding: 5px 8px;\n  margin: 5px;\n  border: 0;\n}\n.v-select.style-selector .vs__dropdown-toggle .vs__selected-options .vs__selected .vs__deselect{\n  fill: white !important;\n  padding: 5px;\n}\n", ""]);

// exports
